import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { Subscription } from 'rxjs';
import { ModeDto, ModeService } from 'src/app/services/mode.service';

@Component({
  selector: 'app-switcher',
  standalone: true,
  imports: [
    CommonModule,
    TablerIconsModule,
  ],
  templateUrl: './app-switcher.component.html',
  styleUrl: './app-switcher.component.scss',
})
export class AppSwitcherComponent implements OnInit, OnDestroy {
  private readonly modeService = inject(ModeService);
  private readonly router = inject(Router);
  private sub?: Subscription;

  availableModes: ModeDto[] = [];
  activeMode: ModeDto | null = null;
  menuOpen = false;

  ngOnInit(): void {
    this.sub = this.modeService.getActiveMode$().subscribe((m) => (this.activeMode = m));
    this.modeService.hydrateFromStorage();
    this.modeService.loadModes().subscribe({
      next: (r) => {
        this.availableModes = r.availableModes ?? [];
        if (!this.activeMode && r.defaultMode) {
          this.modeService.setActiveMode(r.defaultMode);
        }
      },
      error: () => {
        this.availableModes = [];
      },
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  get showSwitcher(): boolean {
    return this.availableModes.length > 1;
  }

  toggleMenu(open: boolean): void {
    this.menuOpen = open;
  }

  selectMode(mode: ModeDto): void {
    if (!this.activeMode || mode.id === this.activeMode.id) {
      this.menuOpen = false;
      return;
    }
    this.modeService.setActiveMode(mode);
    this.menuOpen = false;
    const route = mode.defaultRoute?.startsWith('/')
      ? mode.defaultRoute
      : `/${mode.defaultRoute}`;
    void this.router.navigateByUrl(route);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(ev: MouseEvent): void {
    const target = ev.target as HTMLElement;
    if (!target.closest('.app-switcher')) {
      this.menuOpen = false;
    }
  }
}
